module.exports = __webpack_public_path__ + "static/media/5.70d3bca7.jpg";